import Alpine from "alpinejs";
import clipboard from '@ryangjchandler/alpine-clipboard';
import collapse from '@alpinejs/collapse'
import persist from '@alpinejs/persist'

import "./js/theme";
import "./js/alpine-store";
import "./js/alpine-money";

window.Alpine = Alpine;

window.countryProvinceData = [];

Alpine.plugin(persist);
Alpine.plugin(collapse);
Alpine.plugin(clipboard);
Alpine.start();
